import { dispatch } from "../recontext/store";

export function updateTeams(querySnapshot) {
  const teams = {};
  querySnapshot.forEach(function(doc) {
    teams[doc.id] = doc.data();
  });
  dispatch("SET_TEAMS", { teams });
}

export function updateTeamLikers(querySnapshot) {
  const teamLikers = {};
  querySnapshot.forEach(function(doc) {
    teamLikers[doc.id] = doc.data().likers;
  });
  dispatch("SET_TEAM_LIKERS", { teamLikers });
}

export function updateMe(user) {
  localStorage.setItem("USER_DATA", JSON.stringify(user));
  dispatch("SET_USER", { user });
}

export function catchError(error, resolve) {
  dispatch("SHOW_NOTIFICATION", {
    message: "Oops! Something went wrong",
    type: "warning"
  });
  console.log(error);
  resolve(false);
}
